import './lqbPricerLoanParameters.scss';
import {CalculationNotificationServiceName, ToastNotificationServiceName} from "../../../utils/names/serviceNames";
import {LqbPricerResultDialog} from "../lqb_pricer_results_dialog/LqbPricerResultDialog";

export class LqbPricerLoanParameters {

    static instance = {
        controller: [
            '$scope',
            '$mdDialog',
            ToastNotificationServiceName,
            CalculationNotificationServiceName,
            LqbPricerLoanParameters
        ],
        bindings: {'pricerResult': '<'},
        template: require('./lqbPricerLoanParameter.html')
    };

    constructor($scope, $mdDialog, toastNotificationService, calculationNotificationService) {
        this.$mdDialog = $mdDialog;
        this.calculationsService = calculationNotificationService;
        this.toastNotificationService = toastNotificationService;
        this.$scope = Object.assign($scope, {
            getPricerTerm: this.getPricerTerm,
            openOtherEstimatesDialog: this.openOtherEstimatesDialog
        });

    }

    openOtherEstimatesDialog = ($event) => {
        this.calculationsService.getLqbExecutionsResultsForCalculation(this.$scope.pricerResult.calculationExecutionId)
            .then(resp => {
                this.$mdDialog.show(LqbPricerResultDialog.instance($event, resp.data))
            }, err => {
                this.toastNotificationService.generateErrorMessage("Failed to fetch calculation lqb execution results!");
            })
    };

    getPricerTerm = (term) => term ? term + ' Years' : 'Unknown';

    getLoanTerm = (termMonth) => {
        if (termMonth) {
            return this.getPricerTerm(termMonth / 12);
        }
        return 'unknown';
    };

    $onInit = () => {
        let result = this.pricerResult;
        this.$scope.term = this.getLoanTerm(result.term);
        this.$scope.pricerResult = result;
    }
}